import { render } from "./IssueView.vue?vue&type=template&id=25bab34e&scoped=true"
import script from "./IssueView.vue?vue&type=script&lang=js"
export * from "./IssueView.vue?vue&type=script&lang=js"

import "./IssueView.vue?vue&type=style&index=0&id=25bab34e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bab34e"]])

export default __exports__